import { createSafeContext } from "~/contexts";
import type { DataStoreClients } from "../types";

export const [useDataStoreClients, DataStoreClientsContext] =
  createSafeContext<DataStoreClients>("DataStoreClients");
